'use strict';
var _ = require('lodash');
var $ = require('jquery');
var Backbone = require('backbone');
var PubSub = require('tscom-pubsub');
var template = require('../../templates/abcfooter.ejs');
var StorageUtil = require('tscom-util').storageUtil;
var storage = new StorageUtil({ storageMethod: 'cookie' });

module.exports = Backbone.View.extend({
    className: 'view-abc-footer',
    events: {
        'click a': 'trackEvents',
        'click .close-x': 'closeBanner'
    },
    /**
     * Initialize ABC Footer View
     */
    initialize: function (options) {
        _.bindAll(this, 'render');
        this.touLabel = 'dwts-no-tou';
        this.ccpaSettings = options.ccpaSettings;
        this.copyCms = options.copyCms;

        this.listenTo( this.copyCms, 'change:text change:sid change:language', this.render );
    },
    /**
     * Render ABC Footer View
     */
    render: function () {
        this.handleCCPALink();

        var noBanner = storage.fetch(this.touLabel);
        var modal = this.copyCms.get('text').modal;
        var model = _.extend({ noBanner: noBanner }, { modal: modal }, this.copyCms.get('text').view_abc_footer);
        this.$el.html(template(model));
        return this;
    },
    updateHeadlineCopy: function() {
        const headline = this.copyCms.get('text').view_abc_footer.headline;

        this.$('.watch').html( headline );
    },
    /**
     * Track link click events
     */
    trackEvents: function(e) {
        var cta = $(e.currentTarget).text();
        if(!cta.length) return;
        PubSub.trigger('omniture:action','abcFooterClick',cta);
    },
    /**
     * Hide the Terms of Use banner
     */
    closeBanner: function(e) {
        e.preventDefault();
        $('.tou-banner').remove();
        if(!storage.fetch(this.touLabel)) {
            storage.save(this.touLabel, true, 30);
        }
    },

    handleCCPALink: function() {
        if (!this.ccpaSettings.className) return;

        var observer = new MutationObserver(function() {
            const targetNode = document.getElementsByClassName(this.ccpaSettings.className)[0];

            if (targetNode) {
                this.loadCCPAScript();
                observer.disconnect();
            }
        }.bind(this));

        observer.observe(document, { attributes: false, childList: true, characterData: false, subtree: true });
    },

    loadCCPAScript: function() {
        if (!this.ccpaSettings.scriptURL) return;

        var script = document.createElement('script');
        script.src = this.ccpaSettings.scriptURL;

        document.head.appendChild(script);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/abcfooter.js